<template>
  <div v-bind:style="height != null ? 'height: ' + height + 'px;' : ''">
    <div
      style="padding: 16px; border-right: 1px solid #e6e6e6"
      :class="selected ? 'selected' : ''"
    >
      <div class="sub_title_3">
        <span
          style="text-transform: capitalize"
          v-if="param.metricName != null"
          >{{ param.metricName }}</span
        >
        <!-- <span v-if="param.unit != ''"> {{ "(" + param.unit + ")" }}</span> -->
      </div>
      <div class="d-flex mt-2">
        <div v-if="param.value != null" class="data_text_2">
          <span style="font-size: 20px; font-weight: 700">{{
            formattedNumber(param.value)
          }}</span>
        </div>
        <div class="d-flex mt-2">
          <div
            @mouseenter="showTooltipArc"
            @mouseleave="hideTooltipArc"
            v-if="param.achievement != null"
            class="d-inline-flex align-items-center me-2 tooltip-container"
            :class="
              param.achievementStatus === 'UP' ? 'badge_green' : 'badge_red'
            "
          >
            <div v-if="visibleArc" class="tooltip-content">
              <span>Achievement</span>
            </div>
            <IconSvg
              :color="param.achievementStatus === 'UP' ? 'green' : 'red'"
              :type="
                param.achievementStatus === 'UP' ? 'arrow_up' : 'arrow_down'
              "
            />
            <div
              class="data_detil"
              v-bind:style="
                param.achievementStatus === 'UP'
                  ? 'color: green;'
                  : 'color: red;'
              "
            >
              {{ param.achievement }}
            </div>
          </div>
          <div
            @mouseenter="showTooltip"
            @mouseleave="hideTooltip"
            style="cursor: pointer"
            v-if="param.trend != null"
            class="d-inline-flex align-items-center tooltip-container"
            :class="param.trendStatus === 'UP' ? 'badge_green' : 'badge_red'"
          >
            <div
              style="left: 60px !important"
              v-if="visible"
              class="tooltip-content"
            >
              <span>Trend</span>
            </div>
            <IconSvg
              :color="param.trendStatus === 'UP' ? 'green' : 'red'"
              :type="param.trendStatus === 'UP' ? 'chart_up' : 'chart_down'"
            />
            <div
              class="data_detil"
              v-bind:style="
                param.trendStatus === 'UP' ? 'color: green;' : 'color: red;'
              "
            >
              {{ param.trend }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-100 d-inline-flex align-items-center justify-content-between"
      >
        <div style="color: #7a7a7a; font-size: small">
          Period: {{ convertToMMMYYYY(param.month, param.year) }}
        </div>
        <div
          v-if="param.frequency !== null"
          style="
            color: rgb(235 235 235);
            font-size: small;
            background-color: #00a3e9;
            padding: 1%;
            border-radius: 5px;
          "
          :style="
            param.metricId === 'DISTRIBUTION_PENURUNAN_ADUAN_PLNMOBILE'
              ? 'margin-top: -4%'
              : ''
          "
        >
          {{ param.frequency }}
        </div>
      </div>
    </div>
    <ModalDetailBugdetVue
      :showModal="modalBudget.show"
      :dataBudget="dataBudget"
      :titleBudget="titleBudget"
      @closeModal="onCloseModalBudget"
    ></ModalDetailBugdetVue>
  </div>
</template>

<script>
import moment from "moment";

import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";

import ModalDetailBugdetVue from "../modals/ModalDetailBugdet.vue";

export default {
  components: {
    ModalDetailBugdetVue,
    IconSvg,
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      visibleArc: false,
      dataBudget: [],
      titleBudget: "",
      modalBudget: {
        show: false,
        load: false,
      },
    };
  },
  mounted() {},
  methods: {
    convertToMMMYYYY(month, year) {
      if (month !== null) {
        return moment(`${month}, ${year}`, "M, YYYY").format("MMM, YYYY");
      } else {
        return "-";
      }
    },
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
    showTooltipArc() {
      this.visibleArc = true;
    },
    hideTooltipArc() {
      this.visibleArc = false;
    },
    detail(x) {
      this.modalBudget.show = true;
      this.dataBudget = x;
      this.titleBudget = x.metricName + " " + "(" + x.unit + ")";
    },
    onCloseModalBudget(value) {
      this.modalBudget.show = value;
    },
    formattedNumber,
  },
};
</script>
<style scoped>
.selected {
  background-color: #ecf9ff;
}
</style>
